import '../style/screenShare.scss';

import {ComponentChild, FunctionalComponent, h} from "preact";
import {IcoShareAlt} from "./icons";
import {lazy, Suspense} from "preact/compat";

export const ScreenShareButton: FunctionalComponent<{ lastMsgID: any; assetsBaseURL: string; backendBaseURL: string; chatID: string; lightboxCallback: (lightboxContent: ComponentChild) => void }> =
    ({lastMsgID, assetsBaseURL, backendBaseURL, chatID, lightboxCallback}) => {
  
    const ScreenShareDialog = lazy(() => import('./screenShareDialog'));

    const lightboxData = {
      node: (
        <Suspense fallback={null}>
        <ScreenShareDialog backendBaseURL={backendBaseURL}
                           assetsBaseURL={assetsBaseURL}
                           chatID={chatID}
        />
        </Suspense>
      ),
    };
  
    function openDialog(): void {
      lightboxCallback(lightboxData);
    }
    
    //https://static.querlo.com/images/fa-icons/solid/mailbox.svg
    return <div id="screenShare">
            <div className="wrp">
            <button onClick={openDialog} className="shareButt">
                <IcoShareAlt />
            </button>
        </div>
    </div>
};

// export default ScreenShare;
